import {useState} from 'react';
import SectionLayout from './../../../../CommonComponents/Layout/sectionLayout';
import CartConfirmationAction from './../../../../CommonComponents/CommonCartConfirmaton/index';
import CommonCartTable from '../../CommonCartTable';
import './index.css';
import {useDispatch} from 'react-redux';
import {postAdsPayment} from '../../../../../Store/Actions';
import {useNavigate, useParams} from 'react-router-dom';
import {validatePaymentPrice} from '../../../../../Util/commonUtility';
import NavigationComponent from '../../../../CommonComponents/CommonBackButton';
import useLocalization from '../../../../../Localization';

const NormalAdsCartComponent = ({adData, adFeesOptions}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {id} = useParams();
  const {ApplicationString} = useLocalization();

  const [isAdEditing, setISAdEditing] = useState();

  const handlePaymentClick = () => {
    if (validatePaymentPrice(adData[0]?.ad_fee, dispatch)) return;
    return dispatch(
      postAdsPayment(
        {
          adsId: parseInt(id),
        },
        navigate,
      ),
    );
  };
  return (
    <div className='common-cart-container'>
      <div>
        <SectionLayout>
          <div className='common-cart-table-conatiner'>
            <NavigationComponent
              name={ApplicationString['adsComponent.cart.payment.goBackButton']}
              urlPath={ApplicationString['adsComponent.cart.payment.urlPath']}
            />
            <CommonCartTable
              adsData={adData}
              text={ApplicationString['adsComponent.cart.payment.tableTitle']}
              adFeesOptions={adFeesOptions}
              setISAdEditing={setISAdEditing}
            />
          </div>

          <div>
            <CartConfirmationAction
              heading={''}
              price={adData?.length > 0 && adData[0]?.ad_fee}
              onPay={handlePaymentClick}
              isAdEditing={isAdEditing}
            />
          </div>
        </SectionLayout>
      </div>
    </div>
  );
};

export default NormalAdsCartComponent;
